import * as THREE from 'three'


const params = {
  enableShadow: false,
  defaultMaterial: 'basic',
  enableOrbitControls: false,
  showInfo: false,
  bloomParams: {
    exposure: 0.82,
    bloomThreshold: 0.16,
    bloomStrength: 0.94,
    bloomRadius: 0
  },
  lightParams: {
    envIntensity: 0.27,
    directionalIntensity: 0.73
  },
  colorParams: {
    hue: 0,
    saturation: 0.65,
    vibrance: 0.13,
    brightness: 0.05,
    contrast: 1.11,
  },
  modelNames: [
    'living_room',
    'office',
    'smoking_room',
    'abandoned_mansion',
    'mexico_city',
    'sumitomo_sample',
  ],
  modelList: {
    'living_room': '../assets/gltf/living_room/scene.gltf',
    'office': '../assets/gltf/investigator_office/scene.gltf',
    'smoking_room': '../assets/gltf/smoking_room/scene.gltf',
    'abandoned_mansion': '../assets/gltf/fox/fox.glb',
    'mexico_city': '../assets/gltf/mexico_city/scene.gltf',
    // 'sumitomo_sample': '../assets/fbx/sample/sample.fbx'
    'sumitomo_sample': '../assets/gltf/sumitomo.glb'
  },
  sceneSettings: {
    'living_room': {
      scale: new THREE.Vector3(1, 1, 1),
      camPos: new THREE.Vector3(100, 143.0, -250),
      camTarget: new THREE.Vector3(-150, 100, 300),
      bloomParams: {
        exposure: 0.82,
        bloomThreshold: 0.16,
        bloomStrength: 0.94,
        bloomRadius: 0
      }
    },
    'office': {
      scale: new THREE.Vector3(1, 1, 1),
      camPos: new THREE.Vector3(882, 334.0, -201),
      camTarget: new THREE.Vector3(-300, 0, -1000),
      bloomParams: {
        exposure: 1.11,
        bloomThreshold: 0.04,
        bloomStrength: 0.64,
        bloomRadius: 0
      },
      lightParams: {
        envIntensity: 1,
        directionalIntensity: 1
      }
    },
    'smoking_room': {
      scale: new THREE.Vector3(10, 10, 10),
      camPos: new THREE.Vector3(118, 94, 13),
      camTarget: new THREE.Vector3(-150, 0, 0)
    },
    'abandoned_mansion': {
      scale: new THREE.Vector3(10, 10, 10),
      camPos: new THREE.Vector3(113, 333, -181),
      camTarget: new THREE.Vector3(0, 0, 0)
    },
    'mexico_city': {
      scale: new THREE.Vector3(10, 10, 10),
      camPos: new THREE.Vector3(1225, 669, -620),
      camTarget: new THREE.Vector3(0, 0, 0)
    },
    'sumitomo_sample': {
      scale: new THREE.Vector3(100, 100, 100),
      camPos: new THREE.Vector3(3000, 2500, -1500),
      camTarget: new THREE.Vector3(0, 2500, 0),
      bloomParams: {
        exposure: 0.9,
        bloomThreshold: 1,
        bloomStrength: 0.54,
        bloomRadius: 0
      },
    },
  },
  renderInfo: {
    programs: 0,
    geometries: 0,
    textures: 0,
    drawcalls: 0,
    lines: 0,
    points: 0,
    triangles: 0, 
  }
}

class ScenepParameter{
  constructor(){
    this.modelName = 'sample0'
    this.modelPath = this.getModelPath();

    this.bEnableDirLight = true;
    this.bEnableDirLightShadow = true;

    this.bEnableAmbientLight = true;
    this.ambientLightIntensity = 0.2;

    this.envIntensity = 0.2;
  }

  getModelPath(){
    let path = '../assets/'
    if(this.modelName == 'sample0')
      path = path+'sample0.glb'
    else if(this.modelName == 'sample1')
      path = path+'sample01_2.glb'
    else if(this.modelName == 'sample2')
      path = path+'PL002/glb/untitled.glb'
    else if(this.modelName == 'sample3')
      path = path+'PL004/glb/untitled.glb'
    else if(this.modelName == 'sample4')
      path = path+'PL005/glb/untitled.glb'

    return path;
  }

  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  setInitParamsModelParams(){
    // get init parameters from query ?model=AAA&shadow=true
    const modelName = this.getParameterByName('model');
    const enableShadow = this.getParameterByName('shadow');
    const material = this.getParameterByName('material');
    const showInfo = this.getParameterByName('info');
    const enableOrbitControls = this.getParameterByName('control');
   
    if(modelName !== null){
      if(this.modelList[`${modelName}`]){
        this.currentModelmodelName = modelName
        this.currentModelpath = this.modelList[`${modelName}`]
      }
    }

    if(enableShadow !== null)
      this.enableShadow = (enableShadow === 'true');

    if(material !== null)
      this.defaultMaterial = material;

    if(showInfo !== null)
      this.showInfo = (showInfo === 'true');

    if(enableOrbitControls !== null)
      this.enableOrbitControls = (enableOrbitControls === 'true');
  }

}

export default ScenepParameter;
